export default function googleTranslate(
  state = {
    showGoogleTranslate: false,
  },
  action,
) {
  switch (action.type) {
    case 'GOOGLE_TRANSLATE/TOGGLE':
      return {
        ...state,
        showGoogleTranslate: action.doToggle,
      };
    default:
      return state;
  }
}
